import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/**
 * Custom validator for the Steuerbare Resource Id 'soll-wert' field
 * which validates if there is any IST-Daten when trying to update
 */
export class ResourceIdValidator {

    /**
     * Validates if there is any id stored as IST-Daten for the selected planwert
     * @param steuerbareResourceId Optional 'steuerbare' resource id, empty if there is no id stored in DB
     * @param technischeResourceId Optional technical resource id, empty if there is no id stored in DB
     */
    static validate(steuerbareResourceId?: string, technischeResourceId?: string) : ValidatorFn {
        return (control: AbstractControl): ValidationErrors | null => {

            if (!control.value) {
                return null;
            }

            if (control.value && (!steuerbareResourceId && !technischeResourceId)) {
                return { missingIstWert: true };
            }

            return null;
        };
    }
}
